import ApiService from './api.service';
import PermissionService from '@services/permission.service';
export default class AlertService {
    apiService;
    constructor(ControlCenterApiUrl) {
        this.apiService = new ApiService(ControlCenterApiUrl);
    }
    getReceivedAlertsCount = async (userid, unreadOnly = true) => {
        const { usesNextGenSendingEngine } = new PermissionService().permissions;
        try {
            if (usesNextGenSendingEngine()) {
                const { data = {} } = await this.apiService.get(`api/v1/alerts/alertInbox/recipients/${userid}/count`, {
                    status: 'Unread',
                });
                return data?.count ?? 0;
            }
            else {
                const apiUrl = `api/v1/metrics/users/${userid}/receivedalerts/count`;
                const { data = 0 } = (await this.apiService.get(apiUrl, { unreadOnly })) || {};
                return data ?? 0;
            }
        }
        catch (error) {
            console.error(error);
            return 0;
        }
    };
}
